export default __webpack_public_path__ + "static/media/V450_CoC.0deedac0.pdf";